import React from 'react';
import BulkActionBar from '../../../shared/BulkActionBar';
import ProjectTable from './ProjectTable';

/**
 * Trash section component for ProjectList.
 * Shows soft-deleted projects with restoration capability.
 * 
 * @param {Object} props
 * @param {boolean} props.viewMode
 * @param {boolean} props.isTrashOpen
 * @param {Function} props.setIsTrashOpen
 * @param {string} props.trashSearch
 * @param {Function} props.setTrashSearch
 * @param {Array} props.trashList
 * @param {Function} props.handleRestoreProject
 * @param {Object} props.globalPermissions
 * @param {Object} props.tableProps - Props to pass to ProjectTable.
 */
export default function ProjectTrash({
    viewMode,
    isTrashOpen,
    setIsTrashOpen,
    trashSearch,
    setTrashSearch,
    trashList,
    handleRestoreProject,
    handleBulkRestore,
    handleHardDelete,
    handleBulkHardDelete,
    globalPermissions,
    tableProps
}) {
    // Only show in list mode
    if (viewMode !== 'list') return null;

    const trashCount = trashList.length;

    return (
        <>
            {isTrashOpen && (
                <div className="archive-section trash" style={{ maxWidth: '1200px', margin: '20px auto 40px auto', borderTop: '2px solid rgba(255, 59, 48, 0.15)', paddingTop: '10px' }}>
                    <div className="archive-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', marginTop: '10px' }}>
                        <h3 style={{ margin: 0, color: '#ff3b30', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span>🗑️</span> Papierkorb
                        </h3>
                        <p style={{ fontSize: '13px', color: '#86868b', margin: '0 20px', flex: 1, padding: '8px 12px', background: 'rgba(0,0,0,0.03)', borderRadius: '8px' }}>
                            <strong>Hinweis:</strong> Projekte werden nach 30 Tagen endgültig gelöscht.
                        </p>
                        <input
                            className="search-input"
                            style={{ width: '100%', maxWidth: '300px', height: '40px', margin: 0, paddingLeft: '12px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }}
                            placeholder="Im Papierkorb suchen..."
                            value={trashSearch}
                            onChange={e => setTrashSearch(e.target.value)}
                        />
                    </div>

                    {tableProps.selectedProjectIds.length > 0 && tableProps.selectedProjectIds.some(id => trashList.some(p => p.id === id)) && (
                        <div style={{ maxWidth: '1200px', margin: '10px auto', padding: '0 16px', boxSizing: 'border-box' }}>
                            <BulkActionBar 
                                selectedCount={tableProps.selectedProjectIds.filter(id => trashList.some(p => p.id === id)).length}
                                onClearSelection={() => tableProps.setSelectedProjectIds(prev => prev.filter(id => !trashList.some(p => p.id === id)))}
                                hideSelectionText={true}
                                actions={[
                                    {
                                        label: `Wiederherstellen (${tableProps.selectedProjectIds.filter(id => trashList.some(p => p.id === id)).length})`,
                                        icon: '🔄',
                                        onClick: handleBulkRestore
                                    },
                                    {
                                        label: `Dauerhaft löschen`,
                                        icon: '🗑️',
                                        variant: 'danger',
                                        onClick: handleBulkHardDelete
                                    }
                                ]}
                            />
                        </div>
                    )}
                    
                    {trashCount === 0 ? (
                        <div style={{ textAlign: 'center', padding: '60px 40px', color: '#86868b', background: 'rgba(0,0,0,0.02)', borderRadius: '12px', marginTop: '10px' }}>
                            <div style={{ fontSize: '40px', marginBottom: '10px', opacity: 0.5 }}>🗑️</div>
                            Der Papierkorb ist aktuell leer.
                        </div>
                    ) : (
                        <ProjectTable 
                            list={trashList}
                            showBulk={true}
                            globalPermissions={{ ...globalPermissions, delete_projects: true }}
                            {...tableProps}
                            isTrashView={true}
                            handleRestoreProject={handleRestoreProject}
                            handleHardDelete={handleHardDelete}
                        />
                    )}
                </div>
            )}
        </>
    );
}
